import {Component, OnDestroy, OnInit, ViewContainerRef} from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {AppStore} from '../../../store/store';
import {Segment} from '../../segment.model';
import {SegmentValidationDeleteComponent} from './delete/delete.component';
import {SegmentValidationFormComponent} from './form/form.component';
import {SegmentValidationModel} from './validation.model';
import {segmentValidationListSelector} from './validation.reducer';
import {DomSanitizer} from '@angular/platform-browser';
import {SubSink} from 'subsink';
import {SegmentValidationService} from './validation.service';
import {Store} from '@ngrx/store';
import {selectSegmentDetails} from '../../segments.state';

@Component({
  selector: 'app-segment-validation',
  styleUrls: ['validation.component.scss'],
  template: `
    <div class="segment-info-buttons">
      <button mat-mini-fab
              id="btn-add-validation"
              name="add-validation"
              data-cy="button-validation-create"
              (click)="showCreateSegmentValidationDialog()">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <div class="segment-validations"
         data-cy="element-segment-validation-list-item"
         *ngFor="let segmentValidation of segmentValidations">
      <h4 data-cy="element-segment-validation-list-item-headline">{{segmentValidation.name}}</h4>
      <div class="info-list-body">
        <div class="info-list-line">
          <div data-cy="element-segment-validation-list-item-positive"
               class="validation-item"
               matTooltip="{{segmentValidation.positiveExample.name}}"
               matTooltipPosition="above">
            {{segmentValidation.positiveExample.id}}: {{segmentValidation.positiveExample.name}}
          </div>
          <div data-cy="element-segment-validation-list-item-total-population"
               class="validation-item"
               matTooltip="{{segmentValidation.totalPopulation.name}}"
               matTooltipPosition="below">
            {{segmentValidation.totalPopulation.id}}: {{segmentValidation.totalPopulation.name}}
          </div>
        </div>
        <button mat-icon-button
                [matMenuTriggerFor]="menu"
                id="validation-controlls-menu"
                name="controls-menu"
                data-cy="button-segment-validation-controls-menu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item
                  id="button-segment-validation-edit"
                  name="edit"
                  data-cy="button-segment-validation-edit"
                  (click)="showEditSegmentValidationDialog(segmentValidation)">
            <mat-icon>edit</mat-icon>
            <span>Edit</span>
          </button>
          <button mat-menu-item
                  id="button-segment-validation-delete"
                  data-cy="button-segment-validation-delete"
                  name="delete"
                  (click)="showDeleteSegmentValidationDialog(segmentValidation)">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
          <a mat-menu-item *ngIf="selectedSegment"
             id="segment-validation-link-grafana"
             name="grafana"
             target="_blank"
             [href]="getGrafanaLink(segmentValidation)">
            <mat-icon>link</mat-icon>
            <span>Grafana</span>
          </a>
        </mat-menu>
      </div>
      <iframe style="border: none; width: 100%; height: 450px" *appBindOnce
              [src]="getGrafanaLink(segmentValidation)"></iframe>
    </div>
  `
})
export class SegmentValidationComponent implements OnInit, OnDestroy {
  selectedSegment?: Segment;
  segmentValidations!: SegmentValidationModel[];
  createValidationForm!: MatDialogRef<SegmentValidationFormComponent>;
  editValidationForm!: MatDialogRef<SegmentValidationFormComponent>;
  deleteDialogRef!: MatDialogRef<SegmentValidationDeleteComponent>;
  subsink = new SubSink();
  private config!: MatDialogConfig;
  private grafanaBaseUrl = 'https://grafana.vpc.xplosion.de/d/z4sXNOVZz/smarties-segment-kpi-detail';

  constructor(private appStore: AppStore,
              private store: Store,
              private viewContainerRef: ViewContainerRef,
              private dialogService: MatDialog,
              private segmentValidationsService: SegmentValidationService,
              private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.subsink.sink = this.store.select(selectSegmentDetails).subscribe(details => {
      this.selectedSegment = details?.segment;
      if (this.selectedSegment?.id) {
        this.segmentValidationsService.getValidationList(this.selectedSegment.id);
      }
    });
    this.config = new MatDialogConfig();
    this.config.viewContainerRef = this.viewContainerRef;
    this.segmentValidations = segmentValidationListSelector(this.appStore.getState());
    this.subsink.sink = this.appStore.subscribe((state: AppStore) => {
      this.segmentValidations = segmentValidationListSelector(state);
    });
  }

  showCreateSegmentValidationDialog() {
    this.createValidationForm = this.dialogService.open(SegmentValidationFormComponent, this.config);
  }

  showEditSegmentValidationDialog(validation: SegmentValidationModel) {
    this.editValidationForm = this.dialogService.open(SegmentValidationFormComponent, this.config);
    this.editValidationForm.componentInstance.setValidation(validation);
  }

  showDeleteSegmentValidationDialog(validation: SegmentValidationModel) {
    this.deleteDialogRef = this.dialogService.open(SegmentValidationDeleteComponent, this.config);
    this.deleteDialogRef.componentInstance.validation = validation;
  }

  getGrafanaLink(validation: SegmentValidationModel) {

    if (this.selectedSegment) {
      let link = this.grafanaBaseUrl;
      link += `?var-triple=${this.selectedSegment.id}.total.${validation.totalPopulation.id}.positive.${validation.positiveExample.id}`;
      link += `&var-simplestats=${this.selectedSegment.id}`;
      return this.sanitizer.bypassSecurityTrustResourceUrl(link);
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl('');
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }

}
